import { BROADCAST_SET_ATTENDEE_ROSTER } from '../Types';

function setAttendeeRoster(roster) {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_ATTENDEE_ROSTER,
      payload: roster
    };

    dispatch(action);
  };
}

export default setAttendeeRoster;
